const palettes = ['green', 'blue', 'indigo', 'pink', 'orange', 'fastSneaks'];

export default palettes;
